import { render } from "./NodeRedEditor.vue?vue&type=template&id=f8e7c8f6&ts=true"
import script from "./NodeRedEditor.vue?vue&type=script&lang=ts"
export * from "./NodeRedEditor.vue?vue&type=script&lang=ts"

import "./NodeRedEditor.vue?vue&type=style&index=0&id=f8e7c8f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__